<template>
  <div class="carousel-framed" v-if="carouselItems.length>0"
      @touchstart="onTouchStart"
      @touchmove="onTouchMove"
      @touchend="onTouchEnd">
    <h1 class="visually-hidden">{{title}}</h1>
    <div class="carousel-framed__slides-wrapper slides-wrapper fixed-layout">

      <!-- 5 wrapper fissi -->
      <div
        v-for="(wrapper, wIndex) in wrappers"
        :key="'first-' + wIndex"
        class="carousel-framed__slide-wrapper"
        :class="wrapper.class"
      >
        <!-- tutte le slide -->
        <CarouselFramedSlide
          v-for="(item, iIndex) in normalizedItems"
          :key="'first-' + wIndex + '-' + iIndex"
          :item="item"
          :size="wrapper.size"
          :class="getSlideClass(iIndex, wrapper.baseOffset)"
          :active="isSlideActive(iIndex, wrapper.baseOffset)"
          :show-content="isSlideContentVisible(wrapper.baseOffset)"
          :direction="transitionDirection"
          @longpress="handleLongPress"
          @mouseover.native="pauseOnHover"
          @mouseleave.native="resumeOnHover"
          @transitionend.native="(e) => onSlideTransitionEnd(e, iIndex, wrapper.baseOffset)"
        />
      </div>


    </div>
    <div class="carousel-framed__slides-wrapper slides-wrapper fixed-layout carousel-framed__slides-wrapper--mobile_text">
        <!-- 5 wrapper fissi -->
      <div
        v-if="isMobile"
        v-for="(wrapper, wIndexText) in wrappersText"
        :key="'second-' + wIndexText"
        class="carousel-framed__slide-wrapper carousel-framed__slide-wrapper-mobile"
        :class="wrapper.class"
      >
        <!-- tutte le slide -->
        <CarouselFramedSlideText
          v-for="(item, ind) in normalizedItems"
          :key="'second-' + wIndexText + '-' + ind"
          :item="item"
          :size="wrapper.size"
          :class="getSlideClass(ind, wrapper.baseOffset)"
          :active="isSlideActive(ind, wrapper.baseOffset)"
          :show-content="isSlideContentVisible(wrapper.baseOffset)"
          :direction="transitionDirection"
          @longpress="handleLongPress"
          @mouseover.native="pauseOnHover"
          @mouseleave.native="resumeOnHover"
          @transitionend.native="(e) => onSlideTransitionEnd(e, ind, wrapper.baseOffset)"
        />
      </div>

    </div>

    <!-- controlli -->
    <button class="carousel-framed__pause pause-btn" @click="toggleAutoplay" :aria-pressed="isPausedUser">
      <i class="icon icon-play-empty" v-if="isPaused">
        <span class="show-for-sr">play</span>
      </i>
      <i class="icon icon-pause" v-else>
        <span class="show-for-sr">pause</span>
      </i>
    </button>
    <button class="carousel-framed__arrow carousel-framed__arrow--left arrow left" 
    @mouseover="pauseOnHover"
    @mouseleave="resumeOnHover"
    @click="prevSlide">
      <i class="icon icon-arrow-long-sx">
        <msg id="common.carousel.previous.aria" cssClass="show-for-sr"/>
      </i>
    </button>
    <button class="carousel-framed__arrow carousel-framed__arrow--right arrow right" @click="nextSlide"
    @mouseover="pauseOnHover"
          @mouseleave="resumeOnHover">
      <i class="icon icon-arrow-long-dx">
        <msg id="common.carousel.next.aria" cssClass="show-for-sr"/>
      </i>
    </button>
  </div>
</template>

<script>
import CarouselFramedSlide from './CarouselFramedSlide.vue';
import CarouselFramedSlideText from './CarouselFramedSlideText.vue';

export default {
  name: 'CarouselFramed',
  components: { CarouselFramedSlide, CarouselFramedSlideText },
  props: {
    carouselItems: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    autoplaySpeed: {
      type: String,
      default: '5000'
    },
  },
  data() {
    return {
      // isMobile: false,
      currentIndex: 0,
      // Controllo visibilità contenuti a fine transizione (per indice slide)
      finishedIndexes: [],
      isPausedUser: false,
      isHoverPaused: false,
      interval: null,

      touchStartX: 0,
      touchEndX: 0,
      transitionDirection: 'left',

      // Wrapper fissi (posizioni/slot)
      wrappers: [
        { class: "carousel-framed__slide-wrapper--outer carousel-framed__slide-wrapper--outer--left",  size: "outer",  baseOffset: 0 },
        { class: "carousel-framed__slide-wrapper--middle carousel-framed__slide-wrapper--middle--left", size: "middle", baseOffset: 1 },
        { class: "carousel-framed__slide-wrapper--center",                                             size: "center", baseOffset: 2 },
        { class: "carousel-framed__slide-wrapper--middle carousel-framed__slide-wrapper--middle--right",size: "middle", baseOffset: 3 },
        { class: "carousel-framed__slide-wrapper--outer carousel-framed__slide-wrapper--outer--right", size: "outer",  baseOffset: 4 }
      ],
      // Wrapper fissi (posizioni/slot)
      wrappersText: [
        { class: "carousel-framed__slide-wrapper--outer carousel-framed__slide-wrapper--outer--mobile carousel-framed__slide-wrapper--outer--left",  size: "outer",  baseOffset: 0 },
        { class: "carousel-framed__slide-wrapper--middle carousel-framed__slide-wrapper--middle--mobile carousel-framed__slide-wrapper--middle--left", size: "middle", baseOffset: 1 },
        { class: "carousel-framed__slide-wrapper--center carousel-framed__slide-wrapper--center--mobile",                                             size: "center", baseOffset: 2 },
        { class: "carousel-framed__slide-wrapper--middle carousel-framed__slide-wrapper--middle--mobile carousel-framed__slide-wrapper--middle--right",size: "middle", baseOffset: 3 },
        { class: "carousel-framed__slide-wrapper--outer carousel-framed__slide-wrapper--outer--mobile carousel-framed__slide-wrapper--outer--right", size: "outer",  baseOffset: 4 }
      ]
    };
  },
  computed: {
    isPaused() {
      return this.isPausedUser || this.isHoverPaused;
    },
    normalizedItems() {
      const minSlides = 4;
      if (this.carouselItems.length >= minSlides) return this.carouselItems;
      const clone = [...this.carouselItems];
      while (clone.length < minSlides) {
        clone.push(...this.carouselItems);
      }
      return clone.slice(0, minSlides);
    },
    isMobile() {
      return this.$mq  === 'small' || this.$mq   === 'medium';
    }
  },
  methods: {
    getSlideClass(index, baseOffset) {
      const len = this.normalizedItems.length;
      const activeIndex = (this.currentIndex + baseOffset + len) % len;

      if (index === activeIndex) return "slide-active";
      if (index === (activeIndex - 1 + len) % len) return "slide-prev";
      if (index === (activeIndex + 1) % len) return "slide-next";

      return "slide-hidden";
    },
    isSlideActive(index, baseOffset) {
      const len = this.normalizedItems.length;
      const activeIndex = (this.currentIndex + baseOffset + len) % len;
      return index === activeIndex;
    },

    // Contenuto visibile solo quando la slide "attiva" per quello slot ha finito la transizione
    isSlideContentVisible(baseOffset) {
      const len = this.normalizedItems.length;
      const activeIndex = (this.currentIndex + baseOffset + len) % len;
      return !!this.finishedIndexes[activeIndex];
    },

    // A fine transizione (transform/opacity) segno la slide attiva per quello slot come "finita"
    onSlideTransitionEnd(event, _index, baseOffset) {
      // Considera solo transizioni rilevanti
      if (event && event.propertyName) {
        const prop = event.propertyName;
        if (prop.indexOf('transform') === -1 && prop.indexOf('opacity') === -1) return;
      }
      const len = this.normalizedItems.length;
      const activeIndex = (this.currentIndex + baseOffset + len) % len;
      this.$set(this.finishedIndexes, activeIndex, true);
    },

    // Long press (da child) -> pausa utente
    handleLongPress() {
      this.isPausedUser = true;
      this.stopAutoplay();
    },

    // Navigazione
    nextSlide() {
      this.transitionDirection = 'left';
      this.currentIndex = (this.currentIndex + 1) % this.normalizedItems.length;
      this.resetFinishedFlags();
    },
    prevSlide() {
      this.transitionDirection = 'right';
      this.currentIndex = (this.currentIndex - 1 + this.normalizedItems.length) % this.normalizedItems.length;
      this.resetFinishedFlags();
    },

    // Autoplay
    toggleAutoplay() {
      this.isPausedUser = !this.isPausedUser;
      if (!this.isPaused) this.startAutoplay();
      else this.stopAutoplay();
    },
    startAutoplay() {
      this.stopAutoplay();
      this.interval = setInterval(() => {
        if (!this.isPaused) this.nextSlide();
      }, this.autoplaySpeed);
    },
    stopAutoplay() {
      clearInterval(this.interval);
      this.interval = null;
    },

    // Hover pause (non blocca il toggle utente)
    pauseOnHover() {
      this.isHoverPaused = true;
      this.stopAutoplay();
    },
    resumeOnHover() {
      this.isHoverPaused = false;
      if (!this.isPaused) this.startAutoplay();
    },

    // Touch swipe
    onTouchStart(e) {
      this.touchStartX = e.touches[0].clientX;
      this.touchEndX = this.touchStartX;
    },
    onTouchMove(e) {
      // aggiorno per avere l'ultimo punto
      this.touchEndX = e.touches[0].clientX;
    },
    onTouchEnd() {
      const deltaX = this.touchEndX - this.touchStartX;
      if (Math.abs(deltaX) > 50) {
        if (deltaX < 0) this.nextSlide();
        else this.prevSlide();
      }
      // reset
      this.touchStartX = 0;
      this.touchEndX = 0;
    },

    // Utils
    resetFinishedFlags() {
      this.finishedIndexes = Array(this.normalizedItems.length).fill(false);
    },
    markVisibleSlotsAsFinished() {
      const len = this.normalizedItems.length;
      this.wrappers.forEach(wrapper => {
        if (wrapper.size === 'center' || wrapper.size === 'middle') {
          const idx = (this.currentIndex + wrapper.baseOffset + len) % len;
          this.$set(this.finishedIndexes, idx, true);
        }
      });
    }
  },
  mounted() {
    if (this.carouselItems.length === 0) {
      console.log('empty framed carousel items object');
      return;
    }
    // this.isMobile = this.$mq  === 'small' || this.$mq   === 'medium';
    this.resetFinishedFlags();
    this.markVisibleSlotsAsFinished();
    this.startAutoplay();
  },
  beforeDestroy() {
    this.stopAutoplay();
  }
};
</script>
